export default {
  'aws.title': 'Pesanan Amazon',
  'aws.business': 'Produk/ID Pesanan',
  'aws.orderStatus': 'Status Pesanan',
  'aws.aswStatus': 'Status Langganan',
  'aws.orderInfo': 'Informasi Pesanan',
  'aws.expireTime': 'Waktu Kedaluwarsa',
  'aws.createTime': 'Waktu Pembuatan',
  'aws.pending': 'Menunggu Aktivasi',
  'aws.unbind': 'Menunggu Tautan',
  'aws.bound': 'Terhubung',
  'aws.cancelled': 'Dibatalkan',
  'aws.activeText': 'Aktivasi setelah {time}',
  'aws.operate': 'Operasi',
  'aws.bindTips': 'Pesanan menunggu aktivasi, operasi tidak tersedia',
  'aws.bind': 'Ikat',
  'aws.engageLabOrder': 'Pesanan EngageLab',
  'aws.whatsapp.recharge': 'Isi Ulang',
  'aws.whatsapp.recharge.price': 'Jumlah Isi Ulang',
  'aws.apppush.dataCenter': 'Pusat Data',
  'aws.apppush.dau': 'DAU',
  'aws.apppush.vip': 'Durasi VIP',
  'aws.email.tips': 'Paket Email/Lalu Lintas/IP Independen',
  'aws.email': 'Jumlah Email',
  'aws.email.ip': 'Jumlah IP Independen',
  'aws.email.flow': 'Isi Ulang Lalu Lintas',
  'aws.choose.service': 'Pilih Layanan EngageLab',
  'aws.choose.organization': 'Organisasi',
  'aws.choose.nodata': 'Tidak Ada Aplikasi Tersedia',
  'aws.choose.whatsapp': 'Akun Bisnis',
  'aws.choose.app': 'Aplikasi',
  'aws.order.title': 'Ikat Pesanan Amazon',
  'aws.order.information': 'Informasi Pesanan Amazon',
  'aws.order.id': 'ID Pesanan',
  'aws.order.product': 'Jenis Produk',
  'aws.bind.success': 'Pengikatan Berhasil',
  'aws.bind.modal.create': 'Buat {appName}',
  'aws.month': '{number} Bulan',
  'aws.allBusiness': 'Semua Produk',
  'aws.order.status': 'Status Pesanan',
  'aws.aswStatus.refunded': 'Dikembalikan',
  'aws.aswStatus.expired': 'Kedaluwarsa',
  'aws.aswStatus.subscribed': 'Berlangganan',
  'aws.aswStatus.upgraded': 'Ditingkatkan',
  'aws.aswStatus.renewed': 'Diperpanjang Otomatis',
  'aws.aswStatus.cancelled': 'Dibatalkan',
  'aws.aswStatus.refunded.tips':
    'Pesanan ini telah dikembalikan di Amazon, silakan hubungi bisnis untuk detail',
  'aws.aswStatus.upgraded.tips':
    'Pesanan ini telah ditingkatkan di Amazon. Untuk menikmati manfaat yang ditingkatkan di EngageLab, silakan hubungi penjualan untuk bantuan. Paket yang ditingkatkan adalah sebagai berikut:',
  'aws.bindTips.cancelled': 'Pesanan telah dibatalkan di Amazon',
  'aws.bindTips.unbind': 'Pesanan adalah {status} di Amazon, silakan hubungi bisnis untuk detail',
  'aws.bindTips.unbind.status.refunded': 'Dikembalikan',
  'aws.bindTips.unbind.status.expired': 'Kedaluwarsa',
  'aws.bindTips.unbind.status.upgraded': 'Ditingkatkan',
  'aws.bindTips.unbind.status': 'Dikembalikan/Kedaluwarsa/Ditingkatkan',
  'aws.nodata': 'Tidak ada data tersedia',
  'aws.jumpEmail':
    'Silakan pergi ke <a href="https://www.engagelab.com/console/email/#/email/{orgid}/sendSetting/domain" target="_blank">Email</a> untuk mengonfigurasi domain',
};
